//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';
  module
    .controller('progressBarController', ['$scope', 'progressBar',
      function ($scope, progressBar) {
        progressBar = progressBar.getProgressBar();
        progressBar.setColor('#FFFFFF');
        progressBar.setHeight(10);
      },
    ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/progressBarController.js